import { FC } from 'react';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { TaskCenterTypes } from '@frontend/api-task-center';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { useScopedAppFlagStore } from '@frontend/scope';
import {
  Button,
  usePopoverDialog,
  useControlledField,
  Text,
  PopoverDialog,
  RadioField,
  Dot,
} from '@frontend/design-system';
import { contactPanelTaskListTrackingIds, taskCenterTrackingIds } from '../../tracking-ids';
import {
  filtersButtonStyle,
  filterSourceStyle,
  radioFieldStyle,
  rightIconStyle,
  selectedSourceStyle,
} from './common-styles';

interface TaskSourceFilterProps {
  source: TaskCenterTypes.TaskSource | '';
  setSource: (value: TaskCenterTypes.TaskSource) => void;
  trackingIds: typeof contactPanelTaskListTrackingIds.filters | typeof taskCenterTrackingIds.filters;
}

export const TaskSourceFilter: FC<TaskSourceFilterProps> = ({ source, setSource, trackingIds }) => {
  const { getCustomizationFlagValue } = useScopedAppFlagStore();
  const isCICFEnabled = getCustomizationFlagValue(Feature.CALL_INTELLIGENCE);
  const { t } = useTranslation('task-center');
  const { getDialogProps, getTriggerProps } = usePopoverDialog();
  const sourceFiledProps = useControlledField({
    type: 'radio',
    value: source,
    onChange: (value) => setSource(value),
  });

  return (
    <span>
      <Button css={filtersButtonStyle} trackingId={trackingIds.sourceFilter} {...getTriggerProps()}>
        <Icon name='cell-phone' size={16} color='default' />
        <Text weight='regular'>{t('Source')}</Text>
        {source && <Dot color='primary' css={selectedSourceStyle} />}
        <Icon name='alt-caret-right-tiny' color='subdued' css={rightIconStyle} />
      </Button>
      <PopoverDialog {...getDialogProps()} css={filterSourceStyle}>
        <RadioField name='' {...sourceFiledProps}>
          {isCICFEnabled ? (
            <RadioField.Radio
              value={TaskCenterTypes.TaskSource.SOURCE_CALL_INTELLIGENCE}
              trackingId={trackingIds.sourceCallIntelFilter}
            >
              {t('Call Intelligence')}
            </RadioField.Radio>
          ) : null}
          <RadioField.Radio
            value={TaskCenterTypes.TaskSource.SOURCE_TASK_CENTER}
            trackingId={trackingIds.sourceTaskCenterFilter}
          >
            {t('Task Center')}
          </RadioField.Radio>
          <RadioField.Radio
            value={TaskCenterTypes.TaskSource.SOURCE_MESSAGING}
            trackingId={trackingIds.sourceMessagingFilter}
          >
            {t('Messages')}
          </RadioField.Radio>
          <RadioField.Radio
            value={TaskCenterTypes.TaskSource.SOURCE_INSURANCE_ELIGIBILITY}
            css={radioFieldStyle}
            trackingId={trackingIds.sourceInsuranceEligibilityFilter}
          >
            {t('Insurance')}
          </RadioField.Radio>
        </RadioField>
      </PopoverDialog>
    </span>
  );
};
